var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,64A32,32,0,1,1,64,32,32,32,0,0,1,32,64ZM32,3.12A28.88,28.88,0,1,0,60.88,32,28.88,28.88,0,0,0,32,3.12ZM49.93,41.66l-8.1-6V28.31l8.1-6c.57-.43,1.24-.57,1.24.63V41C51.17,42.1,50.64,42.23,49.93,41.66Zm-35.52-5.2V23a1,1,0,0,1,1-1H35a5.49,5.49,0,0,1,5.52,5.48V41a1,1,0,0,1-1,1H19.93A5.51,5.51,0,0,1,14.41,36.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.35477797534970eda6fad262b8d0ce34.svg";
export { ForwardRef as ReactComponent };